import { useReport } from './hooks/use-context';

export function InitialInfos() {
  const { body } = useReport();

  const { reincidente, date, time, classification, area } = body;

  const cellStyle = {
    padding: '4px 8px',
    border: '1px solid black',
    textAlign: 'left' as const,
  };

  const valueStyle = {
    textAlign: 'center' as const,
    backgroundColor: '#ffffcc',
  };

  const headerStyle = {
    backgroundColor: '#d3d3d3',
    fontWeight: 'bold' as const,
    textAlign: 'center' as const,
    padding: '8px',
    border: '1px solid black',
  };

  return (
    <div style={{ marginBottom: '8px' }}>
      {/* Main header box */}
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '3fr 2fr',
          gap: '8px',
          marginBottom: '4px',
        }}
      >
        {/* Left side - Title box */}
        <div
          style={{
            ...headerStyle,
            fontSize: '1.2rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          COMUNICAÇÃO INCIDENTE ATO INSEGURO
        </div>

        {/* Right side - Questions */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '4px',
          }}
        >
          <div style={cellStyle}>REINCIDENTE?</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {reincidente?.answers?.[0]?.option || '-'}
          </div>

          <div style={cellStyle}>DATA</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {date?.answers?.[0]?.content || '-'}
          </div>

          <div style={cellStyle}>HORÁRIO</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {time?.answers?.[0]?.content || '-'}
          </div>

          <div style={cellStyle}>CLASSIFICAÇÃO</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {classification?.answers?.[0]?.content ||
              classification?.answers?.[0]?.option ||
              '-'}
          </div>

          <div style={cellStyle}>ÁREA</div>
          <div style={{ ...cellStyle, ...valueStyle }}>
            {area?.answers?.[0]?.content || '-'}
          </div>
        </div>
      </div>
    </div>
  );
}
